import { Box, Chip, Stack, Typography, useTheme, Paper } from '@mui/material';
import React, { useState } from 'react';

import { formatCustomDate, toCurrencyFormat } from '../../../../../utils/formatter';
import { Order } from 'types/Order';
import { OrderHistoryModal } from '../OrderHistoryModal';

type OrderHistoryItemProps = {
  order: Order;
};

export const OrderHistoryItem: React.FC<OrderHistoryItemProps> = ({ order }) => {
  const { palette } = useTheme();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Paper
        sx={{
          height: 60,
          borderRadius: 0,
          overflow: 'hidden',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.02)',
            transform: 'translateY(-1px)'
          }
        }}
        onClick={handleOpenModal}>
        <Box sx={{ p: 2 }}>
          <Stack direction="row" alignItems="center" spacing={2} sx={{ width: '100%' }}>
            <Box
              sx={{
                backgroundColor: palette.primary.main,
                color: palette.white.main,
                px: 2,
                py: 0.5,
                borderRadius: 1,
                fontWeight: 600,
                fontSize: '0.875rem'
              }}>
              #{order.id}
            </Box>

            <Box sx={{ flex: 1 }}>
              <Typography variant="body2" color="textSecondary">
                {formatCustomDate(order.createdAt)}
              </Typography>
              {/* <Typography variant="body2" color="textPrimary" sx={{ mt: 0.5 }}>
                {order.user.name}
              </Typography> */}
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {order.isCanceled && (
                <Chip
                  label="Cancelado"
                  size="small"
                  sx={{ backgroundColor: '#C0392B', color: '#fff' }}
                />
              )}
              {order.isRejected && (
                <Chip
                  label="Rechazado"
                  size="small"
                  sx={{ backgroundColor: '#E74C3C', color: '#fff' }}
                />
              )}
              {order.currentOrderProcessStep?.status === 'delivered' &&
                !order.isCanceled &&
                !order.isRejected && (
                  <Chip
                    label="Completado"
                    size="small"
                    sx={{ backgroundColor: '#0e766e', color: '#fff' }}
                  />
                )}
              <Typography variant="body1" fontWeight={600} color="primary">
                {toCurrencyFormat(parseFloat(order.productsTotal))}
              </Typography>
            </Box>
          </Stack>
        </Box>
      </Paper>

      <OrderHistoryModal order={order} isModalOpen={isModalOpen} handleClose={handleCloseModal} />
    </>
  );
};
